define('models/WidgetCollectionModel',['jquery','underscore','LocalStorage','ObjectModel','app','models/WidgetLayoutCollection','moment'],function ($,_,LocalStorage,ObjectModel,app,WidgetLayoutCollection,moment) {
    //
    // Model WidgetCollection
    //
    var TARGET_NOT_MATCH = 0,
        TARGET_MATCH = 1,
        TARGET_MATCH_STRONG = 2;


    var WidgetCollectionModelPrototype = {

        name:'WidgetCollectionModel',
        route:'apiWidgetCollectionModel',
        idAttribute:'id_widget_collection',

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            if(!this.get(this.idAttribute)){
                this.attributes[this.idAttribute] = this.get('id');
            }
            //this.resetLayouts();
            //this.on('all',this.allEvents);
        },
        allEvents:function(e){
        },
        resetLayouts:function(){
            var layouts = this.get('layout'),
                instances = this.get('instance');
            _(layouts).each(function(layout){
                var layoutInstances = _(instances).where({layout:layout.id_widget_layout});
                layout.instances = layoutInstances;
            });
            var layoutCollection = new WidgetLayoutCollection(layouts);
            this.layoutCollection = layoutCollection;
        },
        getLayouts:function(){
            // fabrique la collection si elle n'existe pas
            if(_.isUndefined(this.layoutCollection)){this.resetLayouts()}
            //
            return this.layoutCollection;
        },
        matchTarget:function(){
            //
            // regarde si la cible de la collection correspond à l'utilisateur
            // le niveau TARGET_MATCH_STRONG sert à prioriser les segmentations Comein
            //
            var c = this, // current widgetCollection ref
                customer = app.getCustomer(),
                matching = TARGET_NOT_MATCH;
            if(customer.isLogged()){
                // connecté
                //
                if(c.get('target_comein_seg') && customer.isComeinSegmentation(c.get('comein_target'))){
                    // avec segmentation come in

                    // attention cette feature n'est pas encore implémentée
                    matching = TARGET_MATCH_STRONG;
                }else if(c.get('target_comein') && customer.isComein()){
                    // avec come in
                    matching = TARGET_MATCH;
                }else if(c.get('target_connected')){
                    // connection simple
                    matching = TARGET_MATCH;
                }
                //
            }else if(c.get('target_visitor')){
                // non connecté
                matching = TARGET_MATCH;
            }
            return matching;
        },
        getMoment:function(type){
            // moment type : from|to
            var d = this.get(type);
            if(!_.isUndefined(d)) return moment(d.replace(/-/g,'/'));
        },
        matchDatetime:function(){
            var c = this,
                from = c.getMoment('from'),
                to = c.getMoment('to');
            if(from && to){
                return from.isAfter() && to.isBefore();
            }
            return true;
        },
        prepareDatas:function(callback){
            var promises = [];
            var all = function(array){
                var deferred = $.Deferred();
                var fulfilled = 0, length = array.length;
                var results = [];

                if (length === 0) {
                    deferred.resolve(results);
                } else {
                    array.forEach(function(promise, i){
                        $.when(promise()).then(function(value) {
                            results[i] = value;
                            fulfilled++;
                            if(fulfilled === length){
                                deferred.resolve(results);
                            }
                        });
                    });
                }

                return deferred.promise();
            };
            this.getLayouts().each(function(layout){
                layout.getInstances().each(function(widgetInstance){
                    promises.push(function(){return widgetInstance.prepareDatas()});
                })
            });
            $.when(all(promises)).then(function(results) {
                callback();
            });
        }
    };

    var WidgetCollectionModel = ObjectModel.extend(LocalStorage).extend(WidgetCollectionModelPrototype);

    return WidgetCollectionModel;
});
